import { useSelector } from 'react-redux';

const retailerTypes = {
  OPERATOR: 'operator',
  RETAILER: 'retailer',
};

const orderTypes = {
  DROPSHIP: 'dropship',
  MARKETPLACE: 'marketplace',
};

export function useRetailerType() {
  const { supplierRetailer } = useSelector((state) => state.activation);

  const isOperator = supplierRetailer?.retailer_type === retailerTypes.OPERATOR;
  const isDropship = supplierRetailer?.order_type === orderTypes.DROPSHIP;

  return {
    isOperator,
    isRetailer: !isOperator,
    isDropship,
    isMarketplace: !isDropship,
  };
}
